import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { MOD_VERSION_COMMENT_TYPES } from '../../../../../utils/constants';
import { formatDateTime } from '../../../../../utils/formatting';
import { getUsername, getUserRole } from '../../../../../utils/functions';

import CommentHide from '../../../CommentHide/CommentHide';
import CommentShow from '../../../CommentShow/CommentShow';
import CommentRemove from '../../../CommentRemove/CommentRemove';
import ScrollArea from '../../../../ScrollArea/ScrollArea';

import {
    EDIT_COMMENTS_AUTHOR,
    EDIT_COMMENTS_ITEM_MOD_SUMMARY_VERSION,
    EDIT_COMMENTS_MODERATOR_CAPTION,
    EDIT_COMMENTS_MODERATOR_CAPTION_U,
    EDIT_COMMENTS_MODERATOR_CAPTIONS,
} from './translations'

import styles from './EditCommentsItem.module.css'

const CONTENT_MAX_HEIGHT = 200

export default class EditCommentsItem extends React.PureComponent {
    static propTypes = {
        commentId: PropTypes.number.isRequired,
        author: PropTypes.string,
        role: PropTypes.string,
        content: PropTypes.string.isRequired,
        createdAt: PropTypes.string.isRequired,
        gameVersion: PropTypes.string.isRequired,
        modVersion: PropTypes.string,
        status: PropTypes.oneOf([MOD_VERSION_COMMENT_TYPES.REJECTED, MOD_VERSION_COMMENT_TYPES.APPROVED]),
        state: PropTypes.number,

        onClickHideComment: PropTypes.func,
        onClickShowComment: PropTypes.func,
        onClickRemoveComment: PropTypes.func,
    }

    renderName = () => {
        if (getUserRole() === 'admin' || getUserRole() === 'moderator' || getUserRole() === 'robot') {
            return this.props.role === 'admin' || this.props.role === 'moderator' || this.props.role === 'robot' ? 
                    getUsername().spaUsername === this.props.author ? (
                        <div className={styles.name} title={this.props.author}>
                            {EDIT_COMMENTS_MODERATOR_CAPTION_U(EDIT_COMMENTS_MODERATOR_CAPTION, this.props.state)}
                        </div>
                    ) : (
                        <div className={styles.name} title={this.props.author}>
                            {EDIT_COMMENTS_MODERATOR_CAPTIONS(this.props.state)} {/* EDIT_COMMENTS_MODERATOR_CAPTION */}
                        </div>
                    ) 
                    :
                    getUsername().spaUsername === this.props.author ? (
                        <div className={styles.name} title={this.props.author}>
                            {EDIT_COMMENTS_MODERATOR_CAPTION_U(this.props.author, this.props.state)} {/* this.props.author */}
                        </div>
                    ) : (
                        <div className={styles.name} title={this.props.author}>
                            {EDIT_COMMENTS_AUTHOR(this.props.author, this.props.state)} {/* this.props.author */}
                        </div>
                    )
        } else {
            return this.props.role === 'admin' || this.props.role === 'moderator' || this.props.role === 'robot' ? 
                    (
                        <div className={styles.name}>
                            {EDIT_COMMENTS_MODERATOR_CAPTION}
                        </div>
                    ) : (
                        <div className={styles.name}>
                            {EDIT_COMMENTS_MODERATOR_CAPTION_U(this.props.author, this.props.state)}
                        </div>
                    )
        }
    }

    handleHideClick = () => {
        return this.props.onClickHideComment(this.props.commentId)
    }
    handleShowClick = () => {
        return this.props.onClickShowComment(this.props.commentId)
    }

    handleRemoveClick = () => {
        return this.props.onClickRemoveComment(this.props.commentId)
    }

    renderRemoveComment = () => {
        if (this.props.state === 0) {
            return getUserRole() === 'admin' || getUserRole() === 'moderator' || getUserRole() === 'robot' ? 
                <>
                <div className={styles.innerHide} title="Отобразить">
                    <CommentShow onClick={this.handleShowClick} />
                </div>
                <div className={styles.innerRemove} title="Удалить">
                    <CommentRemove onClick={this.handleRemoveClick} />
                </div>
                </> 
                : <div className={styles.innerRemove} title="Удалить">
                    <CommentRemove onClick={this.handleRemoveClick} />
                </div>
        } else if (this.props.state === 2) {
            return getUserRole() === 'admin' || getUserRole() === 'moderator' || getUserRole() === 'robot' ? 
                <>
                <div className={styles.innerHide} title="Отобразить">
                    <CommentShow onClick={this.handleShowClick} />
                </div>
                <div className={styles.innerRemove} title="Удалить">
                    <CommentRemove onClick={this.handleRemoveClick} />
                </div>
                </> 
                : <div className={styles.innerRemove} title="Удалить">
                    <CommentRemove onClick={this.handleRemoveClick} />
                </div>
        } else if (this.props.state === 3) {
            return getUserRole() === 'admin' || getUserRole() === 'moderator' || getUserRole() === 'robot' ? 
                <>
                <div className={styles.innerHide} title="Отобразить">
                    <CommentShow onClick={this.handleShowClick} />
                </div>
                <div className={styles.innerRemove} title="Удалить">
                    <CommentRemove onClick={this.handleRemoveClick} />
                </div>
                </> 
                : <div className={styles.innerRemove} title="Удалить">
                    <CommentRemove onClick={this.handleRemoveClick} />
                </div>
        } else {
            if (getUsername().spaUsername === this.props.author) {
                return getUserRole() === 'admin' || getUserRole() === 'moderator' || getUserRole() === 'robot' ? 
                    <>
                    <div className={styles.innerHide} title="Скрыть">
                        <CommentHide onClick={this.handleHideClick} />
                    </div>
                    <div className={styles.innerRemove} title="Удалить">
                        <CommentRemove onClick={this.handleRemoveClick} />
                    </div>
                    </> 
                    : <div className={styles.innerRemove} title="Удалить">
                        <CommentRemove onClick={this.handleRemoveClick} />
                    </div>
            } else {
                return getUserRole() === 'admin' || getUserRole() === 'moderator' || getUserRole() === 'robot' ? 
                    <>
                    <div className={styles.innerHide} title="Скрыть">
                        <CommentHide onClick={this.handleHideClick} />
                    </div>
                    <div className={styles.innerRemove} title="Удалить">
                        <CommentRemove onClick={this.handleRemoveClick} />
                    </div>
                    </> 
                    : null
            }
        }
    }

    render() {
        const classNameBase = classNames(styles.base, {
            [styles.isApproved]: this.props.status === MOD_VERSION_COMMENT_TYPES.APPROVED,
            [styles.isRejected]: this.props.status === MOD_VERSION_COMMENT_TYPES.REJECTED,
            [styles.hidden]: this.props.state === 0 || this.props.state === 2,
        })

        // я юзер и текущий коммент скрыт или проверяется, если я не автор коммента - не отображать для меня этот коммент, иначе отобразить
        // if admin
        if ( getUserRole() === 'admin' || getUserRole() === 'moderator' || getUserRole() === 'robot' ) {
            return (
                <div className={classNameBase}>
                    {this.renderName()}
                    <div className={styles.inner}>
                        {this.renderRemoveComment()}
                        <ScrollArea contentHeightMax={CONTENT_MAX_HEIGHT}>
                            <div className={styles.message}>{this.props.content}</div>
                        </ScrollArea>
                    </div>
                    <div className={styles.summary}>
                        {this.props.modVersion &&
                        EDIT_COMMENTS_ITEM_MOD_SUMMARY_VERSION(this.props.modVersion, this.props.gameVersion)}
                        <div className={styles.date}>
                            {formatDateTime(this.props.createdAt)}
                        </div>
                    </div>
                </div>
            )
        // else if user && user=author
        } else if ( getUsername().spaUsername === this.props.author ) {
            return this.props.state === 1 || this.props.state === 3 ? (
                <div className={classNameBase}>
                    {this.renderName()}
                    <div className={styles.inner}>
                        {this.renderRemoveComment()}
                        <ScrollArea contentHeightMax={CONTENT_MAX_HEIGHT}>
                            <div className={styles.message}>{this.props.content}</div>
                        </ScrollArea>
                    </div>
                    <div className={styles.summary}>
                        {this.props.modVersion &&
                        EDIT_COMMENTS_ITEM_MOD_SUMMARY_VERSION(this.props.modVersion, this.props.gameVersion)}
                        <div className={styles.date}>
                            {formatDateTime(this.props.createdAt)}
                        </div>
                    </div>
                </div>
            ) : null
        // else
        } else {
            return this.props.state === 1 || this.props.state === 3 ? (
                <div className={classNameBase}>
                    {this.renderName()}
                    <div className={styles.inner}>
                        {this.renderRemoveComment()}
                        <ScrollArea contentHeightMax={CONTENT_MAX_HEIGHT}>
                            <div className={styles.message}>{this.props.content}</div>
                        </ScrollArea>
                    </div>
                    <div className={styles.summary}>
                        {this.props.modVersion &&
                        EDIT_COMMENTS_ITEM_MOD_SUMMARY_VERSION(this.props.modVersion, this.props.gameVersion)}
                        <div className={styles.date}>
                            {formatDateTime(this.props.createdAt)}
                        </div>
                    </div>
                </div>
            ) : null
        }

        /*return (
            <div className={classNameBase}>
                {this.renderName()}
                <div className={styles.inner}>
                    {this.renderRemoveComment()}
                    <ScrollArea contentHeightMax={CONTENT_MAX_HEIGHT}>
                        <div className={styles.message}>{this.props.content}</div>
                    </ScrollArea>
                </div>
                <div className={styles.summary}>
                    {this.props.modVersion &&
                    EDIT_COMMENTS_ITEM_MOD_SUMMARY_VERSION(this.props.modVersion, this.props.gameVersion)}
                    <div className={styles.date}>
                        {formatDateTime(this.props.createdAt)}
                    </div>
                </div>
            </div>
        )*/
    }
}
